import ReactDOM from "react-dom/client";
import App from "./App";
import * as Sentry from "@sentry/react";
import { LicenseInfo } from "@mui/x-license";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}
if (process.env.REACT_APP_ENVIRONMENT !== "local") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/uptain\.de/]
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

LicenseInfo.setLicenseKey(
  "05e9775ea1027a1d0bcc8c9c27decbdcTz0xMzI1MjMsRT0xODE5NjcwMzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI="
);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // TODO: Supposed to be activated when legacy code will be removed
  // Removed because of legacy code are not supporting double exhaustive hooks call, it leads to logical errors
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
